import { ICardEntity, IEnum_Componentblockscarouselblock_Slidesperview, IStoryEntity } from '@/graphql/__generated__/global/types';
import { determineIfSiblingCardHasImage } from './determineIfSiblingCardHasImage';

export type CardSpanValue = 'oneThird' | 'half' | 'twoThirds' | 'oneQuarter' | null;

export const determineCardSpan = (cards: ICardEntity[] | IStoryEntity[], card: ICardEntity | IStoryEntity, slidesPerView?: string, lookAtSiblingCard?: boolean): CardSpanValue => {
    const noOfCards = cards.length;
    const cardIndex = cards.findIndex((item) => item.id === card.id);

    let cardHasImage = false;
    if (card.attributes) {
        if ('Card' in card.attributes) {
            cardHasImage = Boolean(card.attributes?.Card?.image?.data?.attributes?.url) || Boolean(card.attributes?.Card?.video?.data);
        } else if ('hero' in card.attributes) {
            cardHasImage = Boolean(card.attributes?.hero?.image?.image?.data?.attributes?.url);
        }
    }

    // `slidesPerView` takes precedence over noOfCards so we check for it's presence first
    if (slidesPerView === IEnum_Componentblockscarouselblock_Slidesperview.Full || noOfCards === 1) {
        return null;
    }
    if (slidesPerView === IEnum_Componentblockscarouselblock_Slidesperview.Four) {
        return 'oneQuarter';
    }
    if (slidesPerView === IEnum_Componentblockscarouselblock_Slidesperview.Three) {
        return 'oneThird';
    }
    if (slidesPerView === IEnum_Componentblockscarouselblock_Slidesperview.Two) {
        if (cardHasImage) {
            // If this card has an image and so does it's sibling: span 1/2, else span 2/3
            return lookAtSiblingCard && determineIfSiblingCardHasImage(cards, cardIndex) ? 'half' : 'twoThirds';
        } else {
            // If this card doesn't have an image, span 1/3
            return 'oneThird';
        }
    }

    // If noOfCards is a multiple of 3: span 1/3
    // We do this before checking for multiples of 2 so that for larger card numbers (like 6)
    // the cards get split into thirds instead of halves so that they take up less space
    if (noOfCards % 3 === 0) {
        return 'oneThird';
    }

    // If noOfCards is a multiple of 2:
    if (noOfCards % 2 === 0) {
        // If this card has an image and so does it's sibling: span 1/2 else span 2/3
        if (cardHasImage) {
            return determineIfSiblingCardHasImage(cards, cardIndex) ? 'half' : 'twoThirds';
        } else {
            // Else span 1/3
            return 'oneThird';
        }
    }

    if (cardIndex < noOfCards - (noOfCards % 3)) {
        return 'oneThird';
    }

    // Otherwise return null to keep default span in place
    return null;
};
